/* Visual feedback observes server-rendered cart sections; never changes cart values. */
(() => {
  if (window.gsCartFeedback) return;
  window.gsCartFeedback = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let previousTotal, previousFill, currency, frame, displayed, lastFoot, restoreTimer, burstTimer;
  let scheduled = false;
  const seen = new Set();
  try { JSON.parse(sessionStorage.getItem('gs-cart-rewards-seen') || '[]').forEach(id => seen.add(id)); } catch (_) {}
  const remember = id => { seen.add(id); try { sessionStorage.setItem('gs-cart-rewards-seen', JSON.stringify([...seen])); } catch (_) {} };
  const format = (amount, code) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:code}).format(amount / 100);
  const resize = new ResizeObserver(entries => {
    for (const entry of entries) document.documentElement.style.setProperty('--cart-feedback-foot', `${entry.target.getBoundingClientRect().height}px`);
  });
  const refresh = () => {
    scheduled = false;
    const drawer = document.querySelector('.cart-drawer');
    const foot = drawer?.querySelector('[data-confirmed-total]');
    if (!foot) return;
    if (foot !== lastFoot) { resize.disconnect(); resize.observe(foot); lastFoot = foot; }
    const total = Number(foot.dataset.confirmedTotal), code = foot.dataset.cartCurrency || 'EUR';
    if (!Number.isFinite(total)) return;
    const node = foot.querySelector('[data-cart-total]');
    const change = previousTotal !== undefined && code === currency && total !== previousTotal;
    if (node) {
      const finalLabel = format(total, code);
      node.dataset.confirmedLabel = finalLabel;
      // The accessible checkout label always carries the confirmed final amount.
      const checkout = foot.querySelector('[data-checkout]');
      if (checkout) checkout.setAttribute('aria-label', `${document.documentElement.lang.startsWith('en') ? 'Checkout' : 'Finalisez ma commande'} · ${finalLabel}`);
      if (change || (frame && !node.dataset.animating)) {
        cancelAnimationFrame(frame); frame = null;
        const from = displayed ?? previousTotal;
        node.style.minWidth = `${Math.ceil(node.getBoundingClientRect().width)}px`;
        if (!reduced.matches && change) {
          const start = performance.now(); node.dataset.animating = 'true';
          const tick = now => {
            if (!node.isConnected) { frame = null; return; }
            const progress = Math.min(1, (now - start) / 250);
            displayed = Math.round(from + (total - from) * (1 - Math.pow(1-progress,3)));
            node.textContent = progress === 1 ? finalLabel : format(displayed,code);
            if (progress < 1) frame = requestAnimationFrame(tick);
            else { frame = null; delete node.dataset.animating; node.style.minWidth=''; }
          };
          frame = requestAnimationFrame(tick);
        } else { node.textContent=finalLabel; displayed=total; node.style.minWidth=''; }
      } else if (!frame) { displayed=total; if(node.textContent!==finalLabel)node.textContent=finalLabel; }
    }
    const rewards=drawer.querySelector('[data-cart-rewards]');
    const fill=rewards?.querySelector('.cart-rewards__fill');
    const target=fill ? parseFloat(fill.style.width) : undefined;
    if(fill && Number.isFinite(target) && previousFill !== undefined && previousFill !== target && !reduced.matches){
      fill.animate([{width:`${previousFill}%`},{width:`${target}%`}],{duration:250,easing:'ease-out'});
    }
    if (target !== undefined) previousFill=target;
    const candidates=[];
    rewards?.querySelectorAll('[data-reward-confirmed="true"]').forEach(dot=>{
      const id=`${code}:${dot.dataset.rewardId}`;
      if(!seen.has(id)) { if(change && total>previousTotal) candidates.push(dot); remember(id); }
    });
    if(candidates.length){
      candidates.sort((a,b)=>Number(b.dataset.rewardThreshold)-Number(a.dataset.rewardThreshold));
      clearTimeout(burstTimer);
      const dot=candidates[0];
      burstTimer=setTimeout(()=>{
        if(!dot.isConnected || !dot.classList.contains('is-reached'))return;
        const message=rewards.querySelector('.cart-rewards__msg');
        if(message){
          const original=message.innerHTML;
          const shipping=dot.dataset.rewardType==='free_shipping';
          message.textContent=document.documentElement.lang.startsWith('en') ? `${dot.dataset.rewardLabel} unlocked` : shipping ? 'Livraison gratuite débloquée' : `−${dot.dataset.rewardLabel.replace(/^−/,'').replace(' de remise','').replace(' off','')} sur votre panier débloqués`;
          message.setAttribute('role','status');
          clearTimeout(restoreTimer);
          restoreTimer=setTimeout(()=>{if(message.isConnected){message.innerHTML=original;message.removeAttribute('role');}},1800);
        }
        if(reduced.matches)return;
        const burst=document.createElement('span');burst.className='cart-reward-burst';burst.setAttribute('aria-hidden','true');
        const d=dot.getBoundingClientRect(),r=rewards.getBoundingClientRect();
        burst.style.left=`${d.x+d.width/2-r.x}px`;burst.style.top=`${d.y-r.y}px`;
        for(let i=0;i<8;i++){
          const particle=document.createElement('i'),angle=Math.PI*(1.1+i*.8/7);
          particle.style.setProperty('--dx',`${Math.cos(angle)*24}px`);
          particle.style.setProperty('--dy',`${Math.sin(angle)*30}px`);
          particle.style.setProperty('--spin',`${i*47}deg`);burst.append(particle);
        }
        rewards.append(burst);setTimeout(()=>burst.remove(),600);
      },reduced.matches?0:250);
    }
    previousTotal=total;currency=code;
  };
  const schedule=()=>{if(!scheduled){scheduled=true;queueMicrotask(refresh);}};
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  reduced.addEventListener('change',()=>{cancelAnimationFrame(frame);frame=null;previousTotal=undefined;schedule();});
  refresh();
})();
